import { render, staticRenderFns } from "./PresetSortArea.vue?vue&type=template&id=33ca9778&scoped=true&"
import script from "./PresetSortArea.vue?vue&type=script&lang=ts&"
export * from "./PresetSortArea.vue?vue&type=script&lang=ts&"
import style0 from "./PresetSortArea.vue?vue&type=style&index=0&id=33ca9778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca9778",
  null
  
)

export default component.exports